import _ from 'underscore';

import { BaseColumn } from './base-column';
import linkTemplate from './link-template.pug';
import { i18nMap, safeGetString } from '../../i18n-map/i18n-map';
import { isDataExclusion } from '../../adjustment-type';

export class ScopeColumn extends BaseColumn {
  constructor(option) {
    const title = _TL_('Scope');

    super({
      name: 'Scope',
      title,
      i18n: option.i18n,
      property: ['Name', 'CampaignAssociationsCount', 'CampaignTypeFilter', 'Id'],
      sortable: 'CampaignAssociationsCount',
      helpId: isDataExclusion(option.adjustmentType) ? 'pop_BA_DataExclusions_Scope' : 'pop_BA_SeasonalityAdjustments_Scope',
      helpAriaLabel: option.i18n.getString(_TL_('Click to learn more about {{item}}'), { item: option.i18n.getString(title) }),
    });
    this.scope = option.scope;
    this.adjustmentType = option.adjustmentType;
  }

  template({
    value: {
      CampaignAssociationsCount,
      CampaignTypeFilter,
      Id,
      Name,
    },
  }) {
    const { uid, cid, aid } = this.scope.values;
    const pathname = '/campaign/vnext/campaigns';
    let customParams;
    let campaignTypeItems;

    const filterAlias = isDataExclusion(this.adjustmentType) ? 'filterDataExclusionId' : 'filterSeasonalityId';

    if (!_.isEmpty(CampaignTypeFilter)) {
      const campaignTypeEnum = _.map(CampaignTypeFilter, item => (`Enum.CampaignType'${item}'`));
      customParams = `filterAlias=filterSeasonalityCampaignType&filterArguments=${campaignTypeEnum}`;
      const globalizedCampaignTypes = CampaignTypeFilter.map(item => (safeGetString(this.i18n, i18nMap.CampaignTypes, item)));
      campaignTypeItems = globalizedCampaignTypes.join(this.i18n.getString(_TL_(', ')));
    } else {
      customParams = `filterAlias=${filterAlias}&filterArguments=${Id}, ${encodeURIComponent(Name)}`;
    }

    const href = `${pathname}?uid=${uid}&cid=${cid}&aid=${aid}&${customParams}`;
    const filterType = campaignTypeItems || CampaignAssociationsCount || '0';
    const text = `${filterType} ${this.i18n.getString(_TL_('Campaigns'))}`;

    return linkTemplate({
      pathname, customParams, href, text,
    });
  }
}
